// extracted by mini-css-extract-plugin
var _1 = "EntityTabSubTabs-moduleEntityTabSubTabs__c4_31";
var _2 = "EntityTabSubTabs-moduleitem__bQrif";
var _3 = "EntityTabSubTabs-moduleitemActive__f38L_";
export { _1 as "EntityTabSubTabs", _2 as "item", _3 as "itemActive" }
